import * as React from "react";

const SuccessorsFractalSVG = ({ className }: { className?: string }) => (
  <>
    <div className="successors__fractals-wrapper">
      <svg
        width="1439"
        height="374"
        viewBox="0 0 1439 374"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 326.83C87.6864 326.83 131.789 396.472 240 365.211C342.47 335.6 360.998 166.227 480 150.798C584.102 137.288 600.73 214.413 720 201.249C835.949 188.468 839.981 0.729248 959.981 0.729248C1079.98 0.729248 1081.4 148.36 1199.98 166.725C1304.95 182.98 1319.98 119.709 1439.98 119.709"
          stroke="url(#paint0_linear_4661_8534)"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <defs>
          <linearGradient
            id="paint0_linear_4661_8534"
            x1="125.376"
            y1="-3.01287"
            x2="1314.47"
            y2="449.951"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#1E1E1E" />
            <stop offset="1" stop-color="#B0B0B0" />
          </linearGradient>
        </defs>
      </svg>
      <svg
        width="1439"
        height="242"
        viewBox="0 0 1439 242"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1440 11.8746C1320 11.8746 1321.44 120.78 1200 126.057C1080.12 131.258 1071.99 214.332 960 201.149C840.826 187.101 835.93 6.36698 720 1.31993C600.115 -3.88064 600 136.036 480 136.036C360 136.036 360 241.199 240 241.199C120 241.199 120 136.036 0 136.036"
          stroke="url(#paint0_linear_4661_8535)"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <defs>
          <linearGradient
            id="paint0_linear_4661_8535"
            x1="657.35"
            y1="-100.504"
            x2="794.105"
            y2="280.717"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#B61717" />
            <stop offset="0.333333" stop-color="#E24343" />
            <stop offset="0.666667" stop-color="#F37979" />
            <stop offset="1" stop-color="#FFAEAE" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  </>
);

export default SuccessorsFractalSVG;
